import type { ReactNode } from 'react';

const REGISTRATION_MARKS = [
	'top-4 left-4 border-l-2 border-t-2',
	'top-4 right-4 border-r-2 border-t-2',
	'bottom-4 left-4 border-b-2 border-l-2',
	'bottom-4 right-4 border-b-2 border-r-2',
];

export function ScannerPreviewFrame({ children }: { children: ReactNode }) {
	return (
		<div className="rounded-xl border border-slate-200 bg-white p-4">
			<div className="mb-3 flex items-center justify-between gap-3">
				<span className="font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-800">
					QR preview
				</span>
				<span className="flex items-center gap-1.5 text-xs text-slate-500">
					<span className="size-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
					Live
				</span>
			</div>
			<div className="relative flex min-h-64 items-center justify-center overflow-hidden rounded-lg bg-[#fbfcfa] p-6">
				{REGISTRATION_MARKS.map((position) => (
					<span
						key={position}
						aria-hidden="true"
						className={`absolute size-5 border-emerald-500 ${position}`}
					/>
				))}
				{children}
			</div>
			<p className="mt-3 text-center text-xs text-slate-500">
				Check the code with your phone before printing.
			</p>
		</div>
	);
}
